module.exports = __webpack_public_path__ + "img/support-avatar.ef6f824b.svg";